<template>
  <tr :key="test.testId" :class="(selected)? 'test-row table-active' : 'test-row'">
    <th scope="row" class="test-properties">
      <i :class="getTestType(test).icon" :title="getTestType(test).hover"></i>
    </th>
    <td>
      <span>{{ test.title }}</span>
    </td>
  </tr>
</template>

<script setup lang="ts">
export interface TestProps {
  test: TestModel,
  selected: boolean
}

import { useTranslate } from '@/hooks/translate.hook';
import {TestModel} from '@/models/test.model';

const {test, selected} = defineProps<TestProps>()
const t = useTranslate()

function getTestType(test: TestModel) {
  if (test.requireCamera && test.faceDetection) {
    return {
      icon: 'fa-solid fa-masks-theater',
      hover: t('page.list.test.type.face')
    }
  }

  if (test.requireCamera) {
    return {
      icon: 'fa-solid fa-camera',
      hover: t('page.list.test.type.camera')
    }
  }

  if (test.showAnswers) {
    return {
      icon: 'fa-solid fa-list-check',
      hover: t('page.list.test.type.activity')
    }
  }

  return {
    icon: 'fa-solid fa-list',
    hover: t('page.list.test.type.regular')
  }
}
</script>

<style>
.test-properties {
  width: 20px;
}

.test-row {
  cursor: pointer;
}
</style>